import React, { FunctionComponent } from 'react'
import classnames from 'classnames'

import { User } from '../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  adminUsers: User[]
  assignee?: User
  disabled?: boolean
  indexStyle?: boolean
  reassignTask: Callback
  label?: string
  totalTasks?: number
}

export const TaskAdminDropdown: FunctionComponent<Props> = ({
  adminUsers,
  assignee,
  reassignTask,
  label,
  indexStyle,
  disabled,
  totalTasks,
}) => {
  const adminUsersOptions = adminUsers.map(({ id, name }) => {
    return (
      <option key={id} value={id} className="task-assign__option">
        {name}
      </option>
    )
  })

  const taskLength =
    totalTasks === 0 ? 'Assign Tasks' : `Assign Tasks (${totalTasks})`

  return (
    <div className="task-assign">
      {label && (
        <label className="task-assign__label" htmlFor="assign__dropdown">
          {label}
        </label>
      )}

      <select
        data-testid="task-assign__dropdown"
        id="assign__dropdown"
        className={classnames('task-assign__dropdown', {
          'task-assign__dropdown--index': indexStyle,
        })}
        onChange={(event) => reassignTask(event.target.value)}
        value={(assignee && assignee.id) || ''}
        disabled={disabled}
      >
        {indexStyle && (
          <option className="task-assign__option" value="null">
            {taskLength}
          </option>
        )}

        <option className="task-assign__option" value="null">
          Unassign
        </option>

        {assignee && (
          <option
            className={classnames('task-assign__option', {
              'task-assign__option--assigned': assignee,
            })}
            value={assignee.id}
          >
            {assignee.name}
          </option>
        )}

        {adminUsersOptions}
      </select>
    </div>
  )
}
